import React, { useContext } from 'react';
import { ClassroomCredentials } from './ClassroomLoader';

type ClassroomProviderProps = {
  children: React.ReactNode;
  classroomCredentials: ClassroomCredentials | null;
};

const emptyClassroomCred = {} as ClassroomCredentials;
export const ClassroomContext = React.createContext<ClassroomCredentials>(emptyClassroomCred);

/**
 * This is the classroom credential provider for Google Classroom
 */
export const ClassroomProvider = ({ children, classroomCredentials }: ClassroomProviderProps) => (
  <ClassroomContext.Provider value={classroomCredentials || emptyClassroomCred}>{children}</ClassroomContext.Provider>
);

export const useClassroomCredentials = () => useContext(ClassroomContext);
